import $dom from 'cash-dom';
import Glide from '@glidejs/glide';

const machineCloserLook = () => {
  const $machineCloserLookElem = $dom('[data-machine-closer-look]');

  if ($machineCloserLookElem.length === 0 || window.innerWidth > 1020) {
    return false;
  }

  new Glide($machineCloserLookElem[0], {
    type: 'slider',
    startAt: 0,
    perView: 1,
    bound: true
  }).mount();
};

export default machineCloserLook;
